<div class="layout horizontal center middle" style="height: 50px; background-color: #f7f7f7; border:1px solid #ededed; font-size: 16px;
color: #444;">
        {{topicName}}
    </div>
<div class="conversation" #scrollableDialogueContainer style="overflow:auto;height:calc(100% - 150px);width: 100%" class="layout horizontal center top">
    <div style="min-width: 600px">
        <ng-container *ngFor="let message of shownMessages; let i=index;">
            <div class="layout horizontal center middle" style="position: relative; z-index: 7;  clear: both; width: 100%" *ngIf="(i>0 && message.formattedDate!=shownMessages[i-1].formattedDate) || i==0">
                <div style=" border-radius: 20px;padding: 8px 15px; margin: 8px 0; background-color: #f7f7f7;color: #444;">
                    {{message.formattedDate}}
                </div>
            </div>
            <div class="message sent" *ngIf="message.authorId==ownerId">
                {{message.content}}
                <span class="metadata">
                    <span class="time">{{message.formattedTime}}</span>
                    <!-- <span class="tick">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" id="msg-dblcheck-ack" x="2063"
                            y="2076">
                            <path
                                d="M15.01 3.316l-.478-.372a.365.365 0 0 0-.51.063L8.666 9.88a.32.32 0 0 1-.484.032l-.358-.325a.32.32 0 0 0-.484.032l-.378.48a.418.418 0 0 0 .036.54l1.32 1.267a.32.32 0 0 0 .484-.034l6.272-8.048a.366.366 0 0 0-.064-.512zm-4.1 0l-.478-.372a.365.365 0 0 0-.51.063L4.566 9.88a.32.32 0 0 1-.484.032L1.892 7.77a.366.366 0 0 0-.516.005l-.423.433a.364.364 0 0 0 .006.514l3.255 3.185a.32.32 0 0 0 .484-.033l6.272-8.048a.365.365 0 0 0-.063-.51z"
                                fill="#4fc3f7" />
                        </svg>
                    </span> -->
                </span>
            </div>
            <div class="message received" *ngIf="message.authorId!=ownerId">
                {{message.content}}
                <span class="metadata">
                    <span class="time">{{message.formattedTime}}</span>
                </span>
            </div>
        </ng-container>
    </div>
</div>
<div class="layout horizontal center middle" style="height: 100px; background-color: #f7f7f7; border:1px solid #ededed">
    <div style="min-width: 600px;max-width: 800px;">
        <app-input-bar [successfulMessageSending]="successfulMessageSending" (messageSending)="sendMessage($event)"></app-input-bar>
    </div>
</div>
